import { lazy } from 'react';
import { EURASIA36_MERCHANT } from '@root/constants/paths';
import { getEurasia36ContentData } from '@root/constants/formData';
import { getEurasia36VerifyRoutes } from './eurasia36VerifyRoutes';
import { getEurasia36PayRoutes } from './eurasia36PayRoutes';

const Layout = lazy(() => import('@pages/eurasia36/Layout'));

const { header } = getEurasia36ContentData();

export const eurasia36Routes = {
  path: EURASIA36_MERCHANT,
  element: <Layout headerContent={header} />,
  children: [...getEurasia36VerifyRoutes(), ...getEurasia36PayRoutes()]
};
